import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Table, TableBody, TableHeader, TableRow, Modal, Header } from 'semantic-ui-react';
import getUnapprovedCompanyRecruiters from '../../../../services/getUnapprovedCompanyRecruiters';
import Button from '../../../../components/Button';
import  CompanyDropdown  from '../../../../components/Dropdown/CompanyDropdown';
import updateCompanyId from '../../../../services/updateCompanyId';
import { getValueFromRecruiterType } from '../../../../models/recruiterType';
import { toast } from 'react-toastify';
import './JobSingleList.scss';

const notAvailable = 'N/A';

const JobSingleList = (props) => {
    const [modalOpen, setModalOpen] = useState(false);
    const [isViewingRecruiters, setIsViewingRecruiters] = useState(false);
    const [isVerifying, setIsVerifying] = useState(false);
    const [selectedCompany, setSelectedCompany] = useState({id: props.data.id, name: props.data.name});
    const [recruiters, setRecruiters] = useState({ iimjobs: [], hirist: [] });
    const [submitLoading, setSubmitLoading] = useState(false);
    console.log('props.data', props.data);
    const companyId = props.data.id;

    const status = {
        0: 'Pending',
        1: 'Approved',
        2: 'Rejected',
    }

    return (
        <>
        <TableRow>
            <Table.Cell className="managementData" verticalAlign="top">
                {props.data.id ? props.data.id : notAvailable}
            </Table.Cell>
            <Table.Cell className="managementData" verticalAlign="top">
                {props.data.rec_id ? props.data.rec_id: notAvailable}
            </Table.Cell>
            <Table.Cell className="managementData" verticalAlign="top">
                {props.data.admin_id ? props.data.admin_id : notAvailable}
            </Table.Cell>

            <Table.Cell className="managementData" verticalAlign="top">
                {props.data.status >=0 ? status[props.data.status] : notAvailable}
            </Table.Cell>

            <Table.Cell className="managementData" verticalAlign="top">
                {props.data.job_ids ? props.data.jobIds : notAvailable}

            </Table.Cell>
            <Table.Cell className="managementData" verticalAlign="top">
                handleBulkUpload
            </Table.Cell>
            
        </TableRow>
        </>
    );
};

JobSingleList.propTypes = {
    data: PropTypes.object,
    industryData: PropTypes.array,
    executeAccess: PropTypes.bool,
    rejectCompany: PropTypes.func,
    openRecruitersModal: PropTypes.func,
    changeStatus: PropTypes.func,
    onClick: PropTypes.func,
    isRejectedStatus: PropTypes.bool,
    adminId: PropTypes.string.isRequired,
    adminEmail: PropTypes.string.isRequired,
};

export default JobSingleList;
